<template>
  <div class="Release">
    <el-form
      :model="selectForm"
      ref="selectForm"
      :label-position="labelPosition"
      label-width="120"
      inline
      class="custom-formScreen"
    >
      <el-form-item
        label="选择分公司"
        prop="branchCompany"
        v-if="
          [1].includes(str.type) &&
          str.superDepartmentName !== '客服部' &&
          str.superDepartmentName !== '常规客服部'
        "
      >
        <el-select
          v-model="value6"
          placeholder="请选择"
          @change="shopChange6"
          value-key="company_id"
          filterable
        >
          <el-option
            v-for="item in arr6"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="选择子公司"
        prop="sonCompany"
        v-if="[2, 1].includes(str.type)"
      >
        <el-select
          v-model="value7"
          placeholder="请选择"
          value-key="rid"
          @change="shopChange7"
          filterable
        >
          <el-option
            v-for="item in arr7"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择分部门" v-if="!disabledInput2">
        <el-select
          v-model="value2"
          filterable
          placeholder="请选择"
          @change="shopChange2"
        >
          <el-option
            v-for="item2 in this.arr1"
            :key="item2.value"
            :label="item2.departmentName"
            :value="item2"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择组" v-if="!disabledInput3">
        <el-select
          v-model="value3"
          filterable
          placeholder="请选择"
          @change="shopChange3"
        >
          <el-option
            v-for="item3 in this.arr2"
            :key="item3.value"
            :label="item3.groupName"
            :value="item3"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择员工" v-if="!disabledInput4">
        <el-select
          v-model="value4"
          filterable
          placeholder="请选择"
          @change="shopChange4"
        >
          <el-option
            v-for="item4 in this.arr3"
            :key="item4.value"
            :label="item4.roleUserName"
            :value="item4"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择店铺" prop="shopvalue">
        <el-select
          v-model="value5"
          filterable
          placeholder="请选择"
          clearable
          @change="shopChange5"
        >
          <el-option
            v-for="item5 in this.arr4"
            :key="item5.value"
            :label="item5.shopName"
            :value="item5"
            :style="{ color: item5.state === 0 ? 'red' : '' }"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTime">
        <el-date-picker
          v-model="selectForm.startTime"
          align="right"
          type="datetime"
          placeholder="选择日期"
          format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTime">
        <el-date-picker
          v-model="selectForm.endTime"
          align="right"
          type="datetime"
          placeholder="选择日期"
          format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-input
        clearable
        placeholder="请输入查询内容"
        v-model="selectForm.searchStr"
        style="width: 360px; margin-top: 3px"
        @input="selectForm.searchStr = selectForm.searchStr.replace(/\s+/g, '')"
      >
        <el-select
          v-model="selectForm.searchType"
          slot="prepend"
          style="width: 100px"
          clearable
        >
          <el-option label="ParentSKU" value="1"></el-option>
          <el-option label="产品编号" value="3"></el-option>
          <el-option label="标题" value="4"></el-option>
          <el-option label="备注" value="5"></el-option>
        </el-select>
      </el-input>
      <el-button type="primary" style="margin-left: 10px" @click="Search2"
        >搜索</el-button
      >
      <el-button type="primary" @click="searchReset">重置</el-button>
    </el-form>
    <div class="summary_bag">
      <div class="summary_complete_bag">
        <div class="status_button">
          <el-radio-group
            v-model="selectForm.releaseStatus"
            style="margin-bottom: 30px"
            @change="changeStatus"
          >
            <el-radio-button label="88">全部</el-radio-button>
            <el-radio-button label="0">待完善</el-radio-button>
            <el-radio-button label="1">待发布</el-radio-button>
            <el-radio-button label="2">审核中</el-radio-button>
            <el-radio-button label="4">成功</el-radio-button>
            <el-radio-button label="3">失败</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <!-- 符合查询条件的产品共-->
      <div class="summary_pagenum">
        <div class="summary_query">
          符合查询条件的产品共
          <span>{{ count }}</span>
          件
        </div>
      </div>
      <div class="summary_content">
        <div class="summary_batch">
          <span>已选择产品{{ piece }}件</span>
          <template>
            <span
              @click="addNewProduct()"
              style="cursor: pointer"
              v-if="system == 5"
              >创建</span
            >
            <span
              @click="copyProduc(false)"
              style="cursor: pointer"
              v-if="system == 5"
              >复制</span
            >
            <span
              @click="deleteProduct(false)"
              style="cursor: pointer"
              v-if="system == 5"
              >删除</span
            >
            <span
              @click="displayProduc(false)"
              style="cursor: pointer"
              v-if="system == 5"
              >发布</span
            >
            <span
              @click="tbProduc(false)"
              style="cursor: pointer"
              v-if="system == 5"
              >同步</span
            >
          </template>
        </div>
        <div class="summary_list">
          <!-- 头部 -->
          <el-table
            :data="tableList"
            style="width: 100%"
            v-loading="load_data"
            element-loading-text="拼命加载中"
            border
            @selection-change="on_batch_select"
            :header-cell-style="iscenter"
            stripe
            class="pg-table"
            :cell-class-name="'pg-cell'"
            :header-cell-class-name="'pg-header-cell'"
            fit
          >
            <!-- :cell-style="style" -->
            <el-table-column
              width="50"
              type="selection"
              align="center"
            ></el-table-column>
            <el-table-column label="图片" width="120" align="left">
              <template slot-scope="scope">
                <el-popover
                  trigger="hover"
                  placement="right"
                  v-if="scope.row.images && scope.row.images.length > 0"
                  :open-delay="600"
                >
                  <img :src="scope.row.images[0]" class="prduct_img" alt />
                  <div class="scope_img" slot="reference">
                    <img :src="scope.row.images[0]" alt />
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              width="320"
              label="标题/SKU/店铺/分类/完成度"
              prop="productNumber"
              align="left"
            >
              <template slot-scope="scope">
                <div>
                  <el-link
                    :href="
                      'https://www.ozon.ru/product/ProductID/' +
                      scope.row.productId
                    "
                    target="_blank"
                    type="primary"
                    >{{ scope.row.name }}</el-link
                  >
                </div>
                <div>{{ scope.row.sku }}</div>
                <div>{{ scope.row.shopName }}</div>
                <div>{{ scope.row.cnFullName }}</div>
                <div>{{ scope.row.completeness + "%" }}</div>
              </template>
            </el-table-column>
            <el-table-column
              width="80"
              prop="productType"
              label="状态"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.releaseStatus == 0" type="info"
                  >待完善</el-tag
                >
                <el-tag v-if="scope.row.releaseStatus == 1" type="warning"
                  >待发布</el-tag
                >
                <el-tag v-if="scope.row.releaseStatus == 2">审核中</el-tag>
                <el-tag v-if="scope.row.releaseStatus == 3" type="danger"
                  >失败</el-tag
                >
                <el-tag v-if="scope.row.releaseStatus == 4" type="success"
                  >成功</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="角色/时间/审核提示" align="left">
              <template slot-scope="scope">
                <div v-if="scope.row.roleName">{{ scope.row.roleName }}</div>
                <div v-if="scope.row.updateTime">
                  {{ scope.row.updateTime }}
                </div>
                <div
                  v-if="
                    scope.row.uploadResultList &&
                    scope.row.uploadResultList.length > 0
                  "
                >
                  <el-link
                    type="primary"
                    @click="clickBugTip(scope.row.uploadResultList)"
                    >{{ scope.row.uploadResultList }}</el-link
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" :width="100" align="center">
              <template slot-scope="scope">
                <template>
                  <div>
                    <!--待完善、待发布、失败显示-->
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      v-if="
                        (scope.row.releaseStatus == '0' ||
                          scope.row.releaseStatus == '1' ||
                          scope.row.releaseStatus == '3') &&
                        system == 5
                      "
                      @click="clickEdit(scope.row)"
                      >编辑</el-button
                    >
                  </div>
                  <div>
                    <!--待发布：显示 -->
                    <el-button
                      type="primary"
                      icon="el-icon-position"
                      v-if="scope.row.releaseStatus == '1' && system == 5"
                      @click="displayProduc(scope.row)"
                      >发布</el-button
                    >
                  </div>
                  <div>
                    <!--审核中显示-->
                    <el-button
                      type="primary"
                      icon="el-icon-thumb"
                      v-if="scope.row.releaseStatus == '2' && system == 5"
                      @click="tbProduc(scope.row)"
                      >同步</el-button
                    >
                  </div>
                  <div>
                    <el-button
                      type="primary"
                      v-if="system == 5"
                      icon="el-icon-copy-document"
                      @click="copyProduc(scope.row)"
                      style="background: rgb(112, 182, 3)"
                      >复制</el-button
                    >
                  </div>
                  <div>
                    <!--审核中不显示-->
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      v-if="scope.row.releaseStatus != '2' && system == 5"
                      @click="deleteProduct(scope.row)"
                      >删除</el-button
                    >
                  </div>
                  <div>
                    <!--审核中不显示-->
                    <el-button
                      type="primary"
                      icon="el-icon-view"
                      v-if="system < 5 || scope.row.releaseStatus == 4"
                      @click="clickEdit(scope.row, 'chakan')"
                      >查看</el-button
                    >
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              label="SKU"
              min-width="160"
              :show-overflow-tooltip="false"
              align="left"
            >
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column">
                  <div
                    v-for="(item, index) in scope.row.offerBasicVos"
                    :key="index + 'SKU1'"
                    class="item_sku"
                    v-if="index < 3 && !scope.row.isShowAll"
                    style="display: flex; align-items: center"
                  >
                    <el-popover
                      trigger="hover"
                      placement="right"
                      :open-delay="200"
                    >
                      <span v-if="item.releaseStatus == '1'">待发布</span>
                      <span v-if="item.releaseStatus == '2'">审核中</span>
                      <span v-if="item.releaseStatus == '3'">失败</span>
                      <span v-if="item.releaseStatus == '4'">成功</span>
                      <div slot="reference">
                        <div
                          :class="returnClass(item)"
                          @click="clickSKUResult(item)"
                        ></div>
                      </div>
                    </el-popover>
                    <span style="margin-left: 10px">{{ item.sku }}</span>
                  </div>
                  <div
                    v-for="(item, index) in scope.row.offerBasicVos"
                    :key="index + 'SKU2'"
                    class="item_sku"
                    v-if="scope.row.isShowAll"
                    style="display: flex; align-items: center"
                  >
                    <el-popover
                      trigger="hover"
                      placement="right"
                      :open-delay="200"
                    >
                      <span v-if="item.releaseStatus == '1'">待发布</span>
                      <span v-if="item.releaseStatus == '2'">审核中</span>
                      <span v-if="item.releaseStatus == '3'">失败</span>
                      <span v-if="item.releaseStatus == '4'">成功</span>
                      <div slot="reference">
                        <div
                          :class="returnClass(item)"
                          @click="clickSKUResult(item)"
                        ></div>
                      </div>
                    </el-popover>
                    <span style="margin-left: 10px">{{ item.sku }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="stock"
              label="库存"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column">
                  <div
                    v-for="(item, index) in scope.row.offerBasicVos"
                    :key="index + 'stock1'"
                    class="item_sku"
                    v-if="index < 3 && !scope.row.isShowAll"
                  >
                    {{ item.stock ? JSON.parse(item.stock).available : "" }}
                  </div>
                  <div
                    v-for="(item, index) in scope.row.offerBasicVos"
                    :key="index + 'stock2'"
                    class="item_sku"
                    v-if="scope.row.isShowAll"
                  >
                    {{ item.stock ? JSON.parse(item.stock).available : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="波兰(PLN)" width="140" align="center">
              <template slot-scope="scope">
                <div
                  style="
                    display: flex;
                    width: 100%;
                    justify-content: space-between;
                  "
                >
                  <div style="display: flex; flex-direction: column">
                    <div
                      v-for="(item, index) in scope.row.offerBasicVos"
                      :key="index + 'price1'"
                      class="item_sku"
                      v-if="index < 3 && !scope.row.isShowAll"
                    >
                      <span>{{
                        item.sellingMode
                          ? JSON.parse(item.sellingMode).price.amount
                          : ""
                      }}</span>
                    </div>
                    <div
                      v-for="(item, index) in scope.row.offerBasicVos"
                      :key="index + 'price2'"
                      class="item_sku"
                      v-if="scope.row.isShowAll"
                    >
                      <span>{{
                        item.sellingMode
                          ? JSON.parse(item.sellingMode).price.amount
                          : ""
                      }}</span>
                    </div>
                  </div>
                  <div
                    style="display: flex; align-items: center"
                    v-if="
                      scope.row.offerBasicVos &&
                      scope.row.offerBasicVos.length > 3
                    "
                  >
                    <div
                      class="zhankai_shouqi"
                      @click="clickZhankai(scope.row)"
                    >
                      <i
                        class="iconfont icon-zhankai"
                        style="color: #fff"
                        v-if="!scope.row.isShowAll"
                      ></i>
                      <i
                        class="iconfont icon-shouqi"
                        style="color: #fff"
                        v-if="scope.row.isShowAll"
                      ></i>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="捷克(CZK)"
              width="140"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  style="display: flex; width: 100%; justify-content: center"
                >
                  <div style="display: flex; flex-direction: column">
                    <div
                      v-for="(item, index) in scope.row.offerBasicVos"
                      :key="index + 'price1'"
                      class="item_sku"
                      v-if="index < 3 && !scope.row.isShowAll"
                    >
                      <span>{{ returnCzkPrice(item, "allegro-cz") }}</span>
                    </div>
                    <div
                      v-for="(item, index) in scope.row.offerBasicVos"
                      :key="index + 'price2'"
                      class="item_sku"
                      v-if="scope.row.isShowAll"
                    >
                      <span>{{ returnCzkPrice(item, "allegro-cz") }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="斯洛伐克(EUR)"
              width="140"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  style="display: flex; width: 100%; justify-content: center"
                >
                  <div style="display: flex; flex-direction: column">
                    <div
                      v-for="(item, index) in scope.row.offerBasicVos"
                      :key="index + 'price1'"
                      class="item_sku"
                      v-if="index < 3 && !scope.row.isShowAll"
                    >
                      <span>{{ returnCzkPrice(item, "allegro-sk") }}</span>
                    </div>
                    <div
                      v-for="(item, index) in scope.row.offerBasicVos"
                      :key="index + 'price2'"
                      class="item_sku"
                      v-if="scope.row.isShowAll"
                    >
                      <span>{{ returnCzkPrice(item, "allegro-sk") }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="summary_pagenum_block">
            <div class="block">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                @size-change="handleSizeChange"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="count"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="审核提示"
      :visible.sync="dialogVisibleShenhe"
      width="80%"
      top="5vh"
    >
      <div v-for="(item, index) in bugContentList" :key="index">
        {{ item }}
      </div>
      <span slot="footer" style="margin-top: 60px">
        <el-button @click="dialogVisibleShenhe = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="复制产品"
      :visible.sync="dialogVisibleFuzhi"
      width="500px"
      top="5vh"
    >
      <el-form
        :model="dianpuForm"
        :label-position="labelPosition"
        label-width="160"
      >
        <el-form-item label="选择店铺">
          <el-select
            v-model="fuzhiDianpuObj"
            placeholder="请选择店铺"
            @change="changeDianpuId"
            style="margin-left: 20px; width: 300px"
          >
            <el-option
              v-for="item5 in this.arr4"
              :key="item5.value"
              :label="item5.shopName"
              :value="item5"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" style="margin-top: 60px">
        <el-button @click="dialogVisibleFuzhi = false">取 消</el-button>
        <el-button type="primary" @click="clickFuzhi">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上传结果" :visible.sync="dialogResultVisible">
      <div
        v-for="(value, key) in resultContent"
        :key="key"
        style="display: flex; margin-bottom: 5px"
      >
        <div class="item_err">{{ key }}:</div>
        <div class="item_err_content">
          <span v-if="key != 'errors'">{{ value }}</span>
          <div v-if="key == 'errors'">
            <div class="error_item" v-for="(item, index) in value" :key="index">
              {{ item }}
              <!--							<div class="item_err_title"></div>-->
              <!--							<div class="item_err_content"></div>-->
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <create-product
      ref="createProduct"
      :title="title"
      :isChakan="isChakan"
      :system="system"
      @refreshTable="Search2"
    >
    </create-product>
  </div>
</template>

<script>
import CreateProduct from "./createProduct.vue";
import { ajaxPost, Baseurl, ajaxGet } from "@/api/api/api";

export default {
  name: "productDisplay",
  components: {
    CreateProduct,
  },
  data() {
    return {
      //选中的列表
      selectTableList: [],
      //是否为查看状态
      isChakan: false,
      title: "添加产品",
      dialogResultVisible: false,
      resultContent: {},
      bianjiProductId: "",
      loading: null,
      dialogLoding: false,
      batch_select: [],
      productImgArr: [],
      fuzhiId: "",
      //复制店铺的
      fuzhiDianpuObj: {},
      //仓库id
      warehouseId: "",
      //仓库列表
      warehouseIdList: [],
      //选择店铺获得的sellerid
      sellerId: "",
      //选择店铺获得的ShopId
      markShopId: "",
      show: "",
      state: "",
      strSeller: "",
      //标识 1boss 2 部长 3分部长 4 组长 5普通员工
      system: "5",
      //角色id
      rid: "",
      companyInfo: {},
      labelPosition: "right",

      str: "",
      value2: "",
      //组
      value3: "",
      //员工
      value4: "",
      //店铺
      value5: "",
      //分公司
      value6: "",
      //子公司
      value7: "",
      arr: [],
      arr1: [],
      arr2: [],
      arr3: [],
      arr4: [],
      arr5: [],
      arr6: [],
      arr7: [],
      //平台名称
      sellerType: 11,
      disabledInput: "",
      disabledInput2: "",
      disabledInput3: "",
      disabledInput4: "",
      dianpuForm: {},
      selectForm: {
        page: 1,
        size: 20,
        //查询类型
        searchType: "1",
        //查询内容
        searchStr: "",
        startTime: "", //开始时间
        endTime: "", //结束时间
        timeType: 1,
        //角色id
        staffId: "",
        //店铺id
        sellerId: "",
        //公司id
        companyId: "",
        releaseStatus: 88,
        isTranslation: 1,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate();
            },
          },
          {
            text: "上一月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate(-1);
            },
          },
          {
            text: "上两月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate(-2);
            },
          },
          {
            text: "上三月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate(-3);
            },
          },
        ],
      },
      branchCompany: [],
      pageType: "",
      dialogVisible: false,
      //提示bug弹窗
      dialogVisibleShenhe: false,
      //复制弹窗
      dialogVisibleFuzhi: false,
      //审核弹窗提示内容
      bugContentList: [],
      tabPosition: "88",
      load_data: false,
      iscenter: {
        textAlign: "center",
        background: "#f8f8f8",
        color: "#232323",
      },
      currentPage: 1,
      size: 10,
      //page total
      count: 1,
      //已选数量
      piece: 0,
      //是否全选
      checkAll: false,
      tableList: [],
      arrOld: [],
      //公司
      sonCompanyList: [],
      //部门
      departmentList: [],
      //角色
      groupList: [],
      //店铺
      staffList: [],
      loadingStatus: "",
      platform: [
        { sellerType: 1, itemTypeName: "Amazon" },
        { sellerType: 2, itemTypeName: "Shopify" },
        { sellerType: 5, itemTypeName: "Shoplazza" },
        { sellerType: 7, itemTypeName: "Shopline" },
      ],
      platforms: [],
      bizhong: "CNY",
    };
  },
  created() {
    this.sellerId = "";
    this.markShopId = "";
    this.str = JSON.parse(localStorage.getItem("role"));
    this.rid = this.str.rid;
    this.selectForm.staffId = this.str.rid;
    this.selectForm.companyId = this.str.company_id;
    this.strSeller = JSON.parse(localStorage.getItem("sellerInfo"));
    this.show = this.str.system;
    this.system = this.str.system;
    this.state = this.str.system;
    this.init();
    //获取表格数据
    this.get_table_data();
  },
  methods: {
    init() {
      this.loadingStatus = true;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: this.str.rid,
        system: this.str.system,
        companyId: this.str.company_id,
        sellerType: this.sellerType,
      }).then((res) => {
        this.arr = res.data.data.next;
        this.bizhong =
          this.arr && this.arr.length > 0 && this.arr[0].currencyCode
            ? this.arr[0].currencyCode
            : "CNY";
        const { type: companyType } = this.str;
        if (
          companyType === 1 &&
          this.str.superDepartmentName !== "客服部" &&
          this.str.superDepartmentName !== "常规客服部"
        ) {
          this.disabledInput2 = false;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr6 = res.data.data.next;
        } else if (
          companyType === 2 ||
          (companyType === 1 && this.str.superDepartmentName === "客服部") ||
          (companyType === 1 && this.str.superDepartmentName === "常规客服部")
        ) {
          this.disabledInput2 = false;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr7 = res.data.data.next;
        } else if (
          this.state === 1 ||
          (this.str.type === 3 &&
            this.str.system === 5 &&
            this.str.superDepartmentName === "财务部") ||
          (this.str.type === 3 &&
            this.str.system === 5 &&
            this.str.superDepartmentName === "人事部")
        ) {
          this.disabledInput = false;
          this.disabledInput2 = false;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr1 = res.data.data.next;
        } else if (this.state === 2) {
          this.disabledInput = true;
          this.disabledInput2 = false;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr1 = res.data.data.next;
        } else if (this.state === 3) {
          this.disabledInput = true;
          this.disabledInput2 = true;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr2 = res.data.data.next;
        } else if (this.state === 4) {
          this.disabledInput = true;
          this.disabledInput2 = true;
          this.disabledInput3 = true;
          this.disabledInput4 = false;
          this.arr3 = res.data.data.next;
        } else if (this.state === 5) {
          this.disabledInput = true;
          this.disabledInput2 = true;
          this.disabledInput3 = true;
          this.disabledInput4 = true;
          var sellerInfos = res.data.data.next;
          var newArr = [];
          var num = 0;
          for (var i = 0; i < sellerInfos.length; i++) {
            var shop = sellerInfos[i].countryMarks;
            var sellerId = sellerInfos[i].sellerId;
            for (var j = 0; j < shop.length; j++) {
              shop[j].sellerId = sellerId;
              newArr[num] = shop[j];
              // newArr[num] = shop[j];
              num++;
            }
          }
          this.arr4 = newArr;
          // this.arr4 = newArr.sort((a, b) => a.order - b.order);
        }
      });
    },
    calculationDate(type = 0) {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      // 计算新的月份和年份，确保处理负数和跨年的情况
      const newYear = year + Math.floor((month + type - 1) / 12);
      const newMonth = ((month + type - 1 + 12) % 12) + 1;
      this.selectForm.startTime = `${newYear}-${newMonth
        .toString()
        .padStart(2, "0")}-01 00:00:00`;

      const prevStamp =
        new Date(year, month + type, day).getTime() - 3600 * 1000 * 24 * day;
      const prevMonth = `${new Date(prevStamp).getFullYear()}-${
        new Date(prevStamp).getMonth() + 1
      }-${new Date(prevStamp).getDate()}`;
      this.selectForm.endTime = `${prevMonth} 23:59:59`;
    },
    //获取表格数据
    get_table_data() {
      var that = this;
      this.load_data = true;
      var begin = this.selectForm.startTime;
      if (begin == null || begin == "") {
        begin = "";
      } else {
        begin =
          new Date(this.selectForm.startTime)
            .toLocaleDateString()
            .replace(/\//g, "-") +
          " " +
          new Date(this.selectForm.startTime).toTimeString().substr(0, 8);
      }
      var end = this.selectForm.endTime;
      if (end == null || end == "") {
        end = "";
      } else {
        end =
          new Date(this.selectForm.endTime)
            .toLocaleDateString()
            .replace(/\//g, "-") +
          " " +
          new Date(this.selectForm.endTime).toTimeString().substr(0, 8);
      }
      this.loadingStatus = true;
      //将startTime格式强转
      let searchobj = Object.assign({}, this.selectForm, {
        startTime: begin,
        endTime: end,
        page: this.currentPage,
        size: this.size,
      });
      ajaxPost(
        Baseurl + "allegroProductInfo/selectAllegroProductInfos",
        searchobj
      )
        .then((res) => {
          this.load_data = false;
          const { code, message, data } = res.data;
          if (code == 200) {
            this.tableList = data.list.map((item) => {
              item.isShowAll = false;
              item.images = JSON.parse(item.images);
              return item;
            });
            this.count = data.total;
          } else {
            this.$message.error(message);
          }
        })
        .catch(function (e) {});
    },
    // 条件搜索
    search() {
      this.currentPage = 1;
      this.get_table_data();
    },
    //修改size
    handleSizeChange(val) {
      this.size = val;
      this.get_table_data();
    },
    //修改current
    handleCurrentChange(val) {
      this.currentPage = val;
      this.get_table_data();
    },
    //左侧勾选项变化
    on_batch_select(val) {
      var newarr = [];
      this.piece = val.length;
      for (var i = 0; i < val.length; i++) {
        newarr.push(val[i].id);
      }
      this.batch_select = newarr;
      this.selectTableList = val;
    },
    //审核提示
    clickBugTip(val) {
      this.bugContentList = val;
      this.dialogVisibleShenhe = true;
    },
    //创建产品
    addNewProduct() {
      this.title = "添加产品";
      this.$refs.createProduct.openDialog(this.arr4);
    },
    clickEdit(row, type) {
      this.title = type == "chakan" ? "查看产品" : "编辑产品";
      if (type == "chakan") {
        this.isChakan = true;
      } else {
        this.isChakan = false;
      }
      this.$refs.createProduct.editDialog(row.id, this.arr4);
    },
    //重置各页面参数
    resetPage() {
      this.$refs.baseInfo.formData.shopId = undefined;
      this.$refs.baseInfo.formData.sellerId = undefined;
      this.$refs.baseInfo.formData.name = undefined;
      this.$refs.baseInfo.allLeimuName = undefined;
      this.$refs.baseInfo.formData.sku = undefined;
      this.$refs.baseInfo.formData.categoryId = undefined;
      this.$refs.baseInfo.formData.typeId = undefined;
      this.$refs.description.formData.descValue = undefined;
      this.$refs.description.formData.description = undefined;
      this.$refs.description.formData.jsonDescription = undefined;
      this.$refs.description.formData.jsonValue = undefined;
      this.$refs.description.formData.chicunDescription = undefined;
      this.$refs.description.formData.chicunValue = undefined;
      this.$refs.description.isShowJson = false;
      this.$refs.description.isShowChicun = false;
      this.$refs.laiyuan.formData.remark = undefined;
      this.$refs.laiyuan.blue_point = [
        {
          value: undefined,
          type: true,
        },
      ];
      this.$refs.uploadPictures.imgListSelect = [];
      this.$refs.wuliu.formData.depth = undefined;
      this.$refs.wuliu.formData.height = undefined;
      this.$refs.wuliu.formData.vat = "0";
      this.$refs.wuliu.formData.weight = undefined;
      this.$refs.wuliu.formData.width = undefined;
      this.$refs.wuliu.formData.warehouseId = undefined;
      this.$refs.bianti.ParentSKU = undefined;
      this.$refs.bianti.ParentName = undefined;
      this.$refs.bianti.tableList = [
        {
          name: "",
          oldPrice: "", //原价
          price: "", //现价
          stock: "", //库存
          isShowImage: false, //是否展示输入框按钮
          offerId: "", //卖家产品id(自定义sku) 父sku拼接颜色/尺寸等
          primaryImage: "", //主图
          imageList: [],
          colorImage: "", //营销色彩
        },
      ];
      this.$refs.bianti.headerList = [];
      this.$refs.bianti.attrErweiList = [];
    },
    //复制产品
    copyProduc(row) {
      if (!row && this.piece == 0) {
        this.$alert("请至少勾选一件产品！", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (row) {
        this.fuzhiId = row.id;
      } else {
        this.fuzhiId = "";
      }
      this.fuzhiDianpuObj = {};
      this.warehouseId = "";
      this.dialogVisibleFuzhi = true;
    },
    //删除产品
    deleteProduct(row) {
      var that = this;
      if (this.piece == 0 && !row) {
        this.$alert("请至少勾选一件产品！", "提示", {
          confirmButtonText: "确定",
        });
      } else {
        this.$confirm("此操作将永久删除该产品, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              ids: row ? [row.id] : that.batch_select,
            };
            ajaxPost(
              Baseurl + "allegroProductInfo/batchDeleteAllegroProduct",
              params
            ).then((res) => {
              if (res.data.code == 200) {
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
                that.get_table_data();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //发布产品
    displayProduc(row) {
      var that = this;
      if (this.piece == 0 && !row) {
        this.$alert("请至少勾选一件产品！", "提示", {
          confirmButtonText: "确定",
        });
      } else {
        if (!row) {
          //筛选出不是的下标
          let findIndex = this.selectTableList.findIndex((item) => {
            return item.releaseStatus != "1";
          });
          if (findIndex != -1) {
            this.$alert(
              "勾选的第" +
                (findIndex + 1) +
                "项不属于待发布状态,请确认发布内容！",
              "提示",
              {
                confirmButtonText: "确定",
              }
            );
            return;
          }
        }
        this.$confirm("此操作将发布产品, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            ajaxPost(
              Baseurl + "allegroProductInfo/batchReleaseAllegroProduct",
              {
                ids: row ? [row.id] : that.batch_select,
              }
            ).then((res) => {
              if (res.data.code == 200) {
                that.$message({
                  type: "success",
                  message: "发布成功!",
                });
                that.get_table_data();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //同步产品
    tbProduc(row) {
      var that = this;
      if (this.piece == 0 && !row) {
        this.$alert("请至少勾选一件产品！", "提示", {
          confirmButtonText: "确定",
        });
      } else {
        this.$confirm("此操作将同步产品该产品, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            ajaxPost(Baseurl + "ozonProduct/batchDeleteOzonProduct", {
              ids: row ? [row.id] : that.batch_select,
            }).then((res) => {
              if (res.data.code == 200) {
                that.$message({
                  type: "success",
                  message: "同步成功!",
                });
                that.get_table_data();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 产品图片子组件 中上传的图片列表
    ImgList(ImgList) {
      this.productImgArr = ImgList;
    },
    shopChange2(value2) {
      this.arr3 = [];
      this.arr4 = [];
      this.arr5 = [];
      this.value3 = "";
      this.value4 = "";
      this.value5 = "";
      this.rid = value2.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value2.rid,
        system: 3,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        this.arr2 = res.data.data.next;
        this.shopIds = res.data.data.shopIds;
      });
    },
    shopChange3(value3) {
      this.arr4 = [];
      this.arr5 = [];
      this.value4 = "";
      this.value5 = "";
      this.rid = value3.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value3.rid,
        system: 4,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        this.arr3 = res.data.data.next;
        this.shopIds = res.data.data.shopIds;
      });
    },
    shopChange4(value4) {
      this.arr5 = [];
      this.value5 = "";
      this.rid = value4.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value4.rid,
        system: 5,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        var sellerInfos = res.data.data.next;
        var newArr = [];
        var ids = [];
        var num = 0;
        for (var i = 0; i < sellerInfos.length; i++) {
          var shop = sellerInfos[i].countryMarks;
          for (var j = 0; j < shop.length; j++) {
            newArr[num] = shop[j];
            ids[num] = shop[j].shopId;
            num++;
          }
        }
        this.arr4 = newArr;
        this.shopIds = res.data.data.shopIds;
      });
    },
    shopChange5(value5) {
      // this.sellerIds = item;
      // this.rid = ''
      this.shopIds = [value5.shopId];
      this.markShopId = value5.shopId;
      this.selectForm.sellerId = value5.sellerId;
    },
    shopChange6(value6) {
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.arr4 = [];
      this.arr5 = [];
      this.arr7 = [];
      this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";
      this.value5 = "";
      this.value7 = "";
      this.selectForm.companyId = value6.company_id;
      this.rid = value6.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value6.rid,
        system: 1,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr7 = data.next;
          this.shopIds = data.shopIds;
          this.getCompanyMoney();
        }
      });
    },
    shopChange7(value7) {
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.arr4 = [];
      this.arr5 = [];
      this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";
      this.value5 = "";
      this.selectForm.companyId = value7.company_id;
      this.sellerType = "";
      this.rid = value7.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value7.rid,
        system: 1,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr1 = data.next;
          this.shopIds = data.shopIds;
          this.getCompanyMoney();
        }
      });
      this.getItemList();
    },
    Search2() {
      this.currentPage = 1;
      this.get_table_data();
    },
    // 重置
    searchReset() {
      this.selectForm.startTime = undefined;
      this.selectForm.endTime = undefined;
      this.selectForm.searchStr = undefined;
      this.selectForm.searchType = "1";
      this.selectForm.sellerId = "";

      this.input = "";
      this.selectForm.Ymxvalue = "";
      this.selectForm.demandValue = "";
      this.selectForm.purchaseValue = "";
      this.selectForm.domesticvalue = "";
      this.selectForm.domesticLogisticsStatus = "";
      this.selectForm.internationalLogisticsStatus = "";
      this.selectForm.purchaseEstimated = "";
      this.selectForm.logisticsEstimated = "";
      this.selectForm.channelStatus = "";
      this.selectForm.countryMark = "";
      // this.selectForm.startTime = ''
      // this.selectForm.endTime = ''
      this.selectForm.systemSku = "";
      this.selectForm.sku = "";
      (this.purchaseMark = ""), (this.channelMark = ""), (this.orderMark = "");
      this.orderType = "";
      this.currentPage = 1;
      this.size = 20;
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.arr4 = [];
      this.arr5 = [];
      this.arr6 = [];
      this.arr7 = [];
      // this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";
      this.value5 = "";
      this.value6 = "";
      this.value7 = "";
      this.sellerType = "";

      this.orderStatus = "";
      this.purchaseDemandStatus = "";

      this.selectForm.internalConveyNumber = "";
      this.selectForm.conveyNumber = "";

      var str = JSON.parse(localStorage.getItem("role"));
      this.state = str.system;
      this.rid = str.rid;
      this.init();
      this.get_table_data();
    },
    getCompanyMoney() {
      const API = Baseurl + "companyController/selectCompanyBalanceByCompanyId";
      const paramsData = { id: this.selectForm.companyId };

      ajaxPost(API, paramsData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.companyInfo = data;
        }
      });
    },

    //选择开始时间
    startTime(val) {
      var d = new Date(val);
      var datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " 00:00:00";
      this.selectForm.startTime = datetime;
    },
    // 选择结束时间
    endTime(val) {
      var d = new Date(val);
      var datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " 23:59:59";
      this.selectForm.endTime = datetime;
    },
    //修改状态，请求数据接口
    changeStatus() {
      this.currentPage = 1;
      this.get_table_data();
    },
    clickFuzhi() {
      this.dialogVisibleFuzhi = false;
      this.load_data = true;
      var that = this;
      let params = {
        ids: that.fuzhiId ? [that.fuzhiId] : that.batch_select,
        sellerId: that.fuzhiDianpuObj.sellerId,
      };
      ajaxPost(Baseurl + "allegroProductInfo/copyAllegroProduct", params).then(
        (res) => {
          this.load_data = false;
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "复制成功!",
            });
            this.get_table_data();
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        }
      );
    },
    changeDianpuId(val) {
      if (val) {
        this.warehouseIdList = [];
        this.fuzhiDianpuObj = val;
        //通过商铺id获取仓库雷柏
        const API = Baseurl + "ozonProduct/getOzonWarehouseList";
        const paramsData = { sellerId: val.sellerId };
        ajaxPost(API, paramsData).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.warehouseIdList = data;
          }
        });
      } else {
        this.fuzhiDianpuObj = {};
        this.warehouseId = "";
        this.warehouseIdList = [];
      }
    },

    //展开收起
    clickZhankai(row) {
      row.isShowAll = !row.isShowAll;
    },
    //异常
    clickSKUResult(result) {
      if (result.uploadResult) {
        this.dialogResultVisible = true;
        this.resultContent = JSON.parse(result.uploadResult);
      }
    },
    returnClass(item) {
      //待发布
      if (item && item.releaseStatus == "1") {
        return "item_yuan daifabu_yuan";
      }
      //3红4绿
      if (item && item.releaseStatus == "2") {
        return "item_yuan blue_yuan";
      }
      //3红4绿
      if (item && item.releaseStatus == "3") {
        return "item_yuan red_yuan";
      }
      //3红4绿
      if (item && item.releaseStatus == "4") {
        return "item_yuan green_yuan";
      }
    },
    returnCzkPrice(item, objKeyName) {
      let returnPrice = "";
      let jsonObj;
      if (item.additionalMarketplaces) {
        jsonObj = JSON.parse(item.additionalMarketplaces);
      }
      if (
        jsonObj &&
        jsonObj[objKeyName] &&
        jsonObj[objKeyName].sellingMode &&
        jsonObj[objKeyName].sellingMode.price &&
        jsonObj[objKeyName].sellingMode.price.amount
      ) {
        returnPrice = jsonObj[objKeyName].sellingMode.price.amount;
      }
      return returnPrice;
    },
  },
};
</script>

<style lang="scss">
@import "ozon.less";
.Release {
  width: 98%;
  // background: #F7F7F7;
  padding-bottom: 72px;
  .summary_bag {
    width: 98%;
    margin: auto;
    .summary_complete_bag {
      overflow: hidden;
      .summary_complete {
        overflow: hidden;
        padding: 10px 0;
        border-bottom: 1px #eee solid;
        div {
          padding: 0 10px;
          height: 30px;
          border: #2c8dff 1px solid;
          line-height: 30px;
          text-align: center;
          color: #2c8dff;
          float: left;
          border-radius: 4px;
          cursor: pointer;
        }
        .active {
          background: #2c8dff;
          color: #fff;
        }
      }
    }
    .summary_pagenum {
      width: 100%;
      margin-bottom: 10px;
      overflow: hidden;
      background: #f5f5f5;
      .summary_query {
        width: 20%;
        float: left;
        padding: 0 10px;
        line-height: 32px;
        letter-spacing: 1px;
        color: #585858;
        span {
          color: #2c8dff;
        }
      }
      .block {
        float: right;
      }
    }
    .summary_content {
      width: 100%;
      border: 1px solid #eee;
      overflow: hidden;
      .summary_batch {
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid #eee;
        span {
          display: block;
          float: left;
          line-height: 20px;
          margin: 10px 0px;
          padding: 0 20px;
          color: #2c8dff;
          overflow: hidden;
          border-left: 1px #2c8dff solid;
        }
        span:nth-child(1) {
          color: #000;
          border-left: 0px;
        }
      }
    }
    .summary_list {
      .scope_img {
        width: 55px;
        height: 55px;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .oper {
        color: #2c8dff;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
}
.item_sku {
  width: 100%;
}
.custom-formScreen {
  ::v-deep {
    .el-form-item__content {
      width: calc(100% - 125px);
    }
  }
}
.zhankai_shouqi {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background: rgb(168, 168, 168);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  cursor: pointer;
}
.item_yuan {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-left: 5px;
}
.red_yuan {
  background: red;
  cursor: pointer;
}
.blue_yuan {
  background: blue;
}
.green_yuan {
  background: green;
}
.item_err {
  width: 120px;
  text-align: right;
  padding-right: 15px;
}
.item_err_content {
  width: calc(100% - 160px);
}
</style>
